/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagePackageSortimentResponse } from '../../models/page-package-sortiment-response';

export interface GetPackageSortiment$Params {

/**
 * Filter on name
 */
  name?: string;

/**
 * Filter on mainType of package
 */
  mainType?: 'STANDALONE' | 'COLLECTION';

/**
 * Filter on subType of package
 */
  subType?: string;

/**
 * Filter on unit
 */
  unit?: 'LITERS' | 'KILOGRAMS';

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getPackageSortiment(http: HttpClient, rootUrl: string, params?: GetPackageSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<PagePackageSortimentResponse>> {
  const rb = new RequestBuilder(rootUrl, getPackageSortiment.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('mainType', params.mainType, {});
    rb.query('subType', params.subType, {});
    rb.query('unit', params.unit, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagePackageSortimentResponse>;
    })
  );
}

getPackageSortiment.PATH = '/sortiments/packages';
